
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { FeatureService } from '@app/core/services/feature/feature.service';
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
import { environment } from '@env/environment';
const BASE_PATH = environment.basePath;
/**
* This Component manages the presentation logic of Edit screen
*
*/
@Component({
  selector: 'app-master-master-groups',
  templateUrl: './master-master-groups.component.html',
  styleUrls: ['./master-master-groups.component.scss']
})
export class MasterMasterGroupsComponent implements OnInit {

  id: any;
  name: any;
  selectedIndex: number = 0;

  /**
  * Default Constructor of the component
  */
  constructor(
    private snackBarService: DialogBoxService,
    public dialogRef: MatDialogRef<MasterMasterGroupsComponent>,
    private customAuthenticationService: CustomAuthenticationService,
    private featureService: FeatureService
  ) {

  }

  ngOnInit() { }

  doFechar() {
    let titlepopup, subtitlepopup, cancelpopup, okpopup: string
    this.featureService.translatorService
      .getMessage('titleConfirm')
      .subscribe(val => {
        titlepopup = val
      })
    this.featureService.translatorService
      .getMessage('subtitleConfirm')
      .subscribe(val => {
        subtitlepopup = val
      })
    this.featureService.translatorService
      .getMessage('cancelConfirm')
      .subscribe(val => {
        cancelpopup = val
      })
    this.featureService.translatorService
      .getMessage('okConfirm')
      .subscribe(val => {
        okpopup = val
      })

    this.snackBarService.confirmBox({
      lblTitle: titlepopup,
      lblSubtitle: subtitlepopup,
      lblCancelButton: cancelpopup,
      lblConfirmButton: okpopup,
      color: ' red',
      onConfirm: () => {
        this.dialogRef.close();
      },
    });
  }

  selectedIndexChange(val: number) {
    this.selectedIndex = val;
  }

  hasSomePermission() {
    if (
      this.customAuthenticationService.hasPermission(
        'Consultar grupos de investimentos'
      )) {
      return true;
    }
    return false;
  }
}
